// extracted by mini-css-extract-plugin
export default {"typeFilter":"NavBarPlayer_typeFilter__jNRV3","navBar":"NavBarPlayer_navBar__o7G0C"};